import { Editor, Element, Node, Transforms } from 'slate';
import { type EditorPlugin } from '../../types/aha-editor';

const BlockFormatNormalizationsPluginFactory = (type: string): EditorPlugin => {
  // Blocks created using the BlockFormatPluginFactory should not contain
  // any child block nodes
  return {
    name: `Block format normalizations for ${type}`,
    normalizations: [
      {
        type,
        run: (editor, [node, path]) => {
          for (const [child, childPath] of Node.children(editor, path)) {
            if (Element.isElement(child) && Editor.isBlock(editor, child)) {
              Transforms.unwrapNodes(editor, { at: childPath });
              return true;
            }
          }
        },
      },
    ],
  };
};

export default BlockFormatNormalizationsPluginFactory;
